export const languages = [
  {
    code: 'fr',
    name: 'Français ',
    country_code: 'fr',
    dir: 'ltr',
    font: 'Proxima Nova, Bree, Poppins, Helvetica Neue LT Arabic, HS-Ishraq'
  },
  {
    code: 'ar',
    name: 'العربية ',
    dir: 'rtl',
    country_code: 'tn',
    font: 'Helvetica Neue LT Arabic, HS-Ishraq, Poppins'
  },
  {
    code: 'en',
    name: 'English ',
    country_code: 'gb',
    dir: 'ltr',
    font: 'Proxima Nova, Bree, Poppins, Helvetica Neue LT Arabic, HS-Ishraq'
  },
  {
    code: 'th',
    name: 'Thai ',
    country_code: 'th',
    dir: 'ltr',
    font: 'Proxima Nova, Bree, Poppins, Helvetica Neue LT Arabic, HS-Ishraq'
  }
];
